export const NBA_SDQL_PARAMETERS = 'assists, blocks, conference, date, day, defensive rebounds, ' +
    'division, field goals attempted, field goals made, fouls, free throws attempted, free throws made, ' +
    'offensive rebounds, points, rebounds, rest, season, site, start time, steals, team, ' +
    'three pointers attempted, three pointers made, team, time zone, turnovers';
export const NBA_QUERY_TEXT = `To see how the Celtics have performed since 2018 in away games after a loss, use query:`
export const NBA_QUERY_EXAMPLE = 'team=Celtics and season>2018 and p:L and site=away';
export const NBA_SUMMATIVE_QUERY_TEXT = `To get the Celtics pace in all games since the start of 2023, use query: `
export const NBA_SUMMATIVE_QUERY_EXAMPLE = `tA((field goals attempted - offensive rebounds) + turnovers` +
` + (.43 * free throws attempted)) @ season>=2023 and team=Celtics`

export const NCAABB_SDQL_PARAMETERS = 'assists, blocks, conference, date, day, defensive rebounds, ' +
    'field goals attempted, field goals made, fouls, free throws attempted, free throws made, ' +
    'offensive rebounds, points, rank, rebounds, rest, season, site, start time, steals, team, ' +
    'three pointers attempted, three pointers made, team, time zone, turnovers';
export const NCAABB_QUERY_TEXT = `To see how Duke has performed since 2018 in home games after a win, use query:`
export const NCAABB_QUERY_EXAMPLE = 'team=DUKE and season>2018 and p:W and site=home';
export const NCAABB_SUMMATIVE_QUERY_TEXT = `To get Duke's pace in all games since the start of 2023, use query: `
export const NCAABB_SUMMATIVE_QUERY_EXAMPLE = `tA((field goals attempted - offensive rebounds) + turnovers` +
    ` + (.43 * free throws attempted)) @ season>=2023 and team=DUKE`

export const NCAAFB_SDQL_PARAMETERS = 'conference, day, fumbles, interceptions, passing touchdowns, ' +
    'passing yards, passes, penalties, penalty yards, points, rank, rest, rushing touchdowns, rushing yards, ' +
    'rushes, season, site, start time, team, turnovers, week';
export const NCAAFB_QUERY_TEXT = `To see how Clemson has performed since 2018 in home games after a win, use query:`
export const NCAAFB_QUERY_EXAMPLE = 'team=CLEM and season>2018 and p:W and site=home';
export const NCAAFB_SUMMATIVE_QUERY_TEXT = `To get Clemson's average offensive plays in all games ` +
    `since the start of 2023, use query: `
export const NCAAFB_SUMMATIVE_QUERY_EXAMPLE = `tA(passes + rushes) @ season>=2023 and team=CLEM`

export const NFL_SDQL_PARAMETERS = 'conference, day, division, fumbles, interceptions, passing touchdowns, ' +
    'passing yards, passes, penalty yards, points, rest, rushing touchdowns, rushing yards, rushes, season, ' +
    'site, start time, team, time zone, turnovers, week';
export const NFL_QUERY_TEXT = `To see how the Falcons have performed since 2019 in away games after a loss, use query:`
export const NFL_QUERY_EXAMPLE = 'team=Falcons and season>=2019 and p:L and site=away';
export const NFL_SUMMATIVE_QUERY_TEXT = `To get the Falcon's average offensive plays since 2023: `
export const NFL_SUMMATIVE_QUERY_EXAMPLE = `tA(passes + rushes) @ season>=2023 and team=Falcons`

export const localStateButtonStyle = {
    color: 'grey',
    marginTop: 1,
    border: '.5px solid grey',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
        backgroundColor: 'lightgrey',
        cursor: 'pointer',
    },
}

export const getPopperProps = (isMobile: boolean) =>
    ({
        modifiers: [
            {
                name: "preventOverflow",
                options: {
                    boundary: "window",
                },
            },
        ],
        sx: {
            "& .MuiTooltip-tooltip": {
                minWidth: isMobile ? "250px" : "500px",
                maxWidth: "90vw",
                whiteSpace: "normal",
                wordWrap: "break-word",
            },
        }
    })

export const nbaTeamAbbreviations: Record<string, string> = {
    "Hawks": "atl",
    "Celtics": "bos",
    "Nets": "bkn",
    "Hornets": "cha",
    "Bulls": "chi",
    "Cavaliers": "cle",
    "Mavericks": "dal",
    "Nuggets": "den",
    "Pistons": "det",
    "Warriors": "gsw",
    "Rockets": "hou",
    "Pacers": "ind",
    "Clippers": "lac",
    "Lakers": "lal",
    "Grizzlies": "mem",
    "Heat": "mia",
    "Bucks": "mil",
    "Timberwolves": "min",
    "Pelicans": "no",
    "Knicks": "nyk",
    "Thunder": "okc",
    "Magic": "orl",
    "76ers": "phi",
    "Suns": "phx",
    "Trailblazers": "por",
    "Kings": "sac",
    "Spurs": "sas",
    "Seventysixers": "phi",
    "Raptors": "tor",
    "Jazz": "utah",
    "Wizards": "was"
};

export const ncaaImageUrls: Record<string, string>  = {
    Butler: "https://content.sportslogos.net/logos/30/625/thumbs/62574872015.gif",
    Utah: "https://content.sportslogos.net/logos/35/892/thumbs/f59mntuxy6z31v0gapgueoyg2.gif",
    "George Washington": "https://content.sportslogos.net/logos/31/685/thumbs/68559682008.gif",
    "Boise St.": "https://content.sportslogos.net/logos/30/617/thumbs/61734132013.gif",
    Nebraska: "https://content.sportslogos.net/logos/33/766/thumbs/76621462016.gif",
    "Arizona State": "https://content.sportslogos.net/logos/30/604/thumbs/60465632012.gif",
    "Washington St.": "https://content.sportslogos.net/logos/35/905/thumbs/2724.gif",
    Georgetown: "https://content.sportslogos.net/logos/31/686/thumbs/41oxa3jgd3ht8c7a6zf2hbf99.gif",
    Cincinnati: "https://content.sportslogos.net/logos/30/642/thumbs/7482.gif",
    DePaul: "https://content.sportslogos.net/logos/31/656/thumbs/65640102021.gif",
    "Central Florida": "https://content.sportslogos.net/logos/30/635/thumbs/63548652017.gif",
    "Oregon St.": "https://content.sportslogos.net/logos/33/798/thumbs/79813572013.gif",
    "North Texas": "https://content.sportslogos.net/logos/33/782/thumbs/78267462005.gif",
    Colorado: "https://content.sportslogos.net/logos/30/647/thumbs/7489.gif",
    Villanova: "https://content.sportslogos.net/logos/35/897/thumbs/89749622024.gif",
    LoyolaChicago: "https://content.sportslogos.net/logos/32/735/thumbs/73557852019.gif",
    Chattanooga: "https://content.sportslogos.net/logos/30/640/thumbs/64095962020.gif",
    "Southern California": "https://content.sportslogos.net/logos/34/840/thumbs/84036162016.gif",
    Tulane: "https://content.sportslogos.net/logos/34/877/thumbs/87794352017.gif",
    "American U.": "https://content.sportslogos.net/logos/30/601/thumbs/c6bcevlqb0ggdhe3izuko9vbz.gif",
    "Akron": "https://content.sportslogos.net/logos/30/596/thumbs/59689742022.gif",
    "Alabama St.": "https://content.sportslogos.net/logos/30/599/thumbs/2418.gif",
    "Alabama": "https://content.sportslogos.net/logos/30/597/thumbs/59771422018.gif",
    "Arizona": "https://content.sportslogos.net/logos/30/603/thumbs/60395182011.gif",
    "Arkansas": "https://content.sportslogos.net/logos/30/606/thumbs/60692202014.gif",
    "Arkansas St.": "https://content.sportslogos.net/logos/30/605/thumbs/60556122015.gif",
    "Army": "https://content.sportslogos.net/logos/30/609/thumbs/60961542015.gif",
    "Auburn": "https://content.sportslogos.net/logos/30/610/thumbs/61039731968.gif",
    "Baylor": "https://content.sportslogos.net/logos/30/613/thumbs/61311562019.gif",
    "Bradley": "https://content.sportslogos.net/logos/30/621/full/bradley_braves_logo_primary_2012sportslogosnet2771.png",
    "Bryant": "https://content.sportslogos.net/logos/30/5021/thumbs/502126362005.gif",
    "Brigham Young": "https://content.sportslogos.net/logos/30/622/thumbs/62210722021.gif",
    "Clemson": "https://content.sportslogos.net/logos/30/643/thumbs/2451.gif",
    "Cleveland St.": "https://content.sportslogos.net/logos/30/644/thumbs/kwthyzx2swpnggefwaidm12f2.gif",
    "Connecticut": "https://content.sportslogos.net/logos/35/884/thumbs/88464902013.gif",
    "CSU Northridge": "https://content.sportslogos.net/logos/30/628/thumbs/cal_state_northridge_matadors_logo_primary_2023sportslogosnet9394.gif",
    "Creighton": "https://content.sportslogos.net/logos/30/652/thumbs/65227962013.gif",
    "Colorado St.": "https://content.sportslogos.net/logos/30/648/thumbs/64848422021.gif",
    "Dayton": "https://content.sportslogos.net/logos/31/655/thumbs/65553062014.gif",
    "Drake": "https://content.sportslogos.net/logos/31/661/thumbs/66135332015.gif",
    "Duke": "https://content.sportslogos.net/logos/31/663/thumbs/66395011978.gif",
    "Elon University": "https://content.sportslogos.net/logos/31/671/thumbs/67183312016.gif",
    "Florida": "https://content.sportslogos.net/logos/31/675/thumbs/67570762013.gif",
    "Florida Atlantic": "https://content.sportslogos.net/logos/31/677/thumbs/67793322023.gif",
    "Florida Gulf Coast": "https://content.sportslogos.net/logos/31/4946/thumbs/494664472023.gif",
    "Fresno State": "https://content.sportslogos.net/logos/31/681/thumbs/68182932020.gif",
    "Furman": "https://content.sportslogos.net/logos/31/682/thumbs/68277562013.gif",
    "George Mason": "https://content.sportslogos.net/logos/31/684/thumbs/68438882024.gif",
    "Georgia": "https://content.sportslogos.net/logos/31/687/thumbs/68757442015.gif",
    "Georgia Tech": "https://content.sportslogos.net/logos/31/690/thumbs/69087312018.gif",
    "Gonzaga": "https://content.sportslogos.net/logos/31/691/thumbs/69163362011.gif",
    "Grand Canyon": "https://content.sportslogos.net/logos/31/5050/thumbs/505019672023.gif",
    "Hawai'i": "https://content.sportslogos.net/logos/31/696/thumbs/2494.gif",
    "High Point": "https://content.sportslogos.net/logos/31/697/thumbs/69756152012.gif",
    "Houston": "https://content.sportslogos.net/logos/31/700/thumbs/70018072017.gif",
    "Idaho State": "https://content.sportslogos.net/logos/32/705/thumbs/70529292019.gif",
    "Illinois": "https://content.sportslogos.net/logos/32/706/thumbs/70667022022.gif",
    "Illinois St.": "https://content.sportslogos.net/logos/32/707/thumbs/5l5bieqet3144zaiwte9.gif",
    "Incarnate Word": "https://content.sportslogos.net/logos/32/5075/thumbs/507574732011.gif",
    "Iowa State": "https://content.sportslogos.net/logos/32/713/thumbs/71346122008.gif",
    "Jackson State": "https://content.sportslogos.net/logos/32/714/thumbs/71471772007.gif",
    "Jacksonville St.": "https://content.sportslogos.net/logos/32/716/thumbs/84gdv65kg9fdjefh4teoh5355.gif",
    "Jacksonville": "https://content.sportslogos.net/logos/32/715/thumbs/71573342018.gif",
    "Kansas": "https://content.sportslogos.net/logos/32/718/thumbs/t96oee4doe8n2oxaft7f.gif",
    "Kansas St.": "https://content.sportslogos.net/logos/32/719/thumbs/71944342019.gif",
    "K State": "https://content.sportslogos.net/logos/32/719/thumbs/71944342019.gif",
    "Kent St.": "https://content.sportslogos.net/logos/32/720/thumbs/72041732017.gif",
    "Kentucky": "https://content.sportslogos.net/logos/32/721/thumbs/72178322016.gif",
    "Liberty": "https://content.sportslogos.net/logos/32/728/thumbs/72862172013.gif",
    "Lipscomb": "https://content.sportslogos.net/logos/32/729/thumbs/lipscomb_bisons_logo_primary_2014sportslogosnet5511.gif",
    "Louisville": "https://content.sportslogos.net/logos/32/734/thumbs/73446722007.gif",
    "Marquette": "https://content.sportslogos.net/logos/32/741/thumbs/lk47sf36h6g3y141mktt.gif",
    "Manhattan": "https://content.sportslogos.net/logos/32/739/thumbs/73917732012.gif",
    "Maryland": "https://content.sportslogos.net/logos/32/743/thumbs/74354442012.gif",
    "McNeese St.": "https://content.sportslogos.net/logos/32/745/thumbs/74570442011.gif",
    "Memphis": "https://content.sportslogos.net/logos/32/746/thumbs/74692712021.gif",
    "Mercer": "https://content.sportslogos.net/logos/32/747/thumbs/74741962007.gif",
    "Michigan": "https://content.sportslogos.net/logos/32/750/thumbs/75032372016.gif",
    "Michigan St": "https://content.sportslogos.net/logos/32/751/thumbs/75112152010.gif",
    "Middle Tennessee St.": "https://content.sportslogos.net/logos/32/752/thumbs/75282132019.gif",
    "Missouri": "https://content.sportslogos.net/logos/32/757/thumbs/75746882018.gif",
    "Mississippi State": "https://content.sportslogos.net/logos/32/755/thumbs/mississippi_state_bulldogs_logo_primary_2024sportslogosnet5254.gif",
    "Mississippi": "https://content.sportslogos.net/logos/32/755/thumbs/mississippi_state_bulldogs_logo_primary_2024sportslogosnet5254.gif",
    "Montana": "https://content.sportslogos.net/logos/32/759/thumbs/8w2u1hfnzaaqrqh0wy6hmgeh9.gif",
    "Mount St. Mary's": "https://content.sportslogos.net/logos/32/763/thumbs/76311752016.gif",
    "NCWilmington": "https://content.sportslogos.net/logos/33/780/thumbs/78039712015.gif",
    "Nebraska Omaha": "https://content.sportslogos.net/logos/33/5049/thumbs/504963202011.gif",
    "New Mexico": "https://content.sportslogos.net/logos/33/769/thumbs/new_mexico_lobos_logo_primary_2023sportslogosnet1811.gif",
    "Nicholls": "https://content.sportslogos.net/logos/33/773/thumbs/77321912009.gif",
    "Nicholls St.": "https://content.sportslogos.net/logos/33/773/thumbs/77321912009.gif",
    "Norfolk State": "https://content.sportslogos.net/logos/33/774/thumbs/7064.gif",
    "North Alabama": "https://content.sportslogos.net/logos/33/4754/thumbs/475488292022.gif",
    "North Carolina": "https://content.sportslogos.net/logos/33/775/thumbs/77515392015.gif",
    "North Carolina Central": "https://content.sportslogos.net/logos/33/5020/thumbs/502089342006.gif",
    "Northern Arizona": "https://content.sportslogos.net/logos/33/784/thumbs/78446052020.gif",
    "Northern Colorado": "https://content.sportslogos.net/logos/33/4954/thumbs/495484862015.gif",
    "Northern Iowa": "https://content.sportslogos.net/logos/33/786/thumbs/78616812021.gif",
    "Oklahoma": "https://content.sportslogos.net/logos/33/793/thumbs/79328022018.gif",
    "Oklahoma State": "https://content.sportslogos.net/logos/33/794/thumbs/79454632019.gif",
    "Oregon": "https://content.sportslogos.net/logos/33/797/thumbs/by8dfvb6j89hs5nrvlb1ibx5e.gif",
    "Presbyterian": "https://content.sportslogos.net/logos/33/5053/thumbs/505380632013.gif",
    "Portland State": "https://content.sportslogos.net/logos/33/805/thumbs/80548492016.gif",
    "Purdue": "https://content.sportslogos.net/logos/33/809/thumbs/80966442012.gif",
    "Queens University of Charlotte": "https://content.sportslogos.net/logos/33/6859/thumbs/685952812023.gif",
    "Robert Morris": "https://content.sportslogos.net/logos/33/816/thumbs/81640582020.gif",
    "Samford": "https://content.sportslogos.net/logos/34/824/thumbs/82413822016.gif",
    "San Diego St.": "https://content.sportslogos.net/logos/34/826/thumbs/82676662013.gif",
    "San Francisco": "https://content.sportslogos.net/logos/34/827/thumbs/82715532012.gif",
    "San Jose St.": "https://content.sportslogos.net/logos/34/828/thumbs/82875122018.gif",
    "Santa Clara": "https://content.sportslogos.net/logos/34/829/thumbs/82950002016.gif",
    "SIU Edwardsville": "https://content.sportslogos.net/logos/34/5051/thumbs/505151782023.gif",
    "Southern": "https://content.sportslogos.net/logos/34/845/thumbs/84570962016.gif",
    "Southern Methodist": "https://content.sportslogos.net/logos/34/842/thumbs/84293122012.gif",
    "St. Bonaventure": "https://content.sportslogos.net/logos/34/848/thumbs/84823232016.gif",
    "St. Francis (PA)": "https://content.sportslogos.net/logos/34/849/thumbs/84947802013.gif",
    "St. John's": "https://content.sportslogos.net/logos/34/850/thumbs/85039202015.gif",
    "St. Joseph's (PA)": "https://content.sportslogos.net/logos/34/851/thumbs/85163652018.gif",
    "St. Mary's": "https://content.sportslogos.net/logos/34/852/thumbs/mfhe5ysvfgzgt0wxt8hcz89pv.gif",
    "Sam Houston State": "https://content.sportslogos.net/logos/34/823/thumbs/82378332020.gif",
    "Stanford": "https://content.sportslogos.net/logos/34/854/thumbs/85459932014.gif",
    "Saint Louis": "https://content.sportslogos.net/logos/34/822/thumbs/82293832022.gif",
    "Tennessee": "https://content.sportslogos.net/logos/34/861/thumbs/86166262015.gif",
    "Tarleton State": "https://content.sportslogos.net/logos/34/6818/thumbs/681862662018.gif",
    "Texas": "https://content.sportslogos.net/logos/34/865/thumbs/86561462019.gif",
    "Texas A&M": "https://content.sportslogos.net/logos/34/866/thumbs/86656342021.gif",
    "Texas Tech": "https://content.sportslogos.net/logos/34/870/thumbs/4661.gif",
    "Troy": "https://content.sportslogos.net/logos/34/876/thumbs/87610792016.gif",
    "UAB": "https://content.sportslogos.net/logos/35/879/thumbs/87915182015.gif",
    "UC Irvine": "https://ucirvinesports.com/images/main_logo.png",
    "UNLV": "https://content.sportslogos.net/logos/35/888/thumbs/88889482018.gif",
    "UC Davis": "https://content.sportslogos.net/logos/30/1831/thumbs/183112042019.gif",
    "UC Riverside": "https://content.sportslogos.net/logos/35/5023/thumbs/502335682016.gif",
    "UC San Diego": "https://content.sportslogos.net/logos/35/6819/thumbs/681961752018.gif",
    "UCLA": "https://content.sportslogos.net/logos/35/882/thumbs/88285272017.gif",
    "Utah St.": "https://content.sportslogos.net/logos/35/893/thumbs/89352172019.gif",
    "Utah Valley": "https://content.sportslogos.net/logos/35/2606/thumbs/260643992008.gif",
    "VCU": "https://content.sportslogos.net/logos/35/899/thumbs/89973792014.gif",
    "Vanderbilt": "https://content.sportslogos.net/logos/35/895/thumbs/vanderbilt_commodores_logo_primary_2022sportslogosnet9393.gif",
    "Western Kentucky": "https://content.sportslogos.net/logos/35/2724/thumbs/272498192018.gif",
    "Wichita St.": "https://content.sportslogos.net/logos/35/911/thumbs/91127002010.gif",
    "Wisconsin": "https://content.sportslogos.net/logos/35/914/thumbs/91436912017.gif",
    "Wofford": "https://content.sportslogos.net/logos/35/916/thumbs/91664602019.gif",
    "Xavier": "https://content.sportslogos.net/logos/35/919/thumbs/91958462008.gif",
    "Yale": "https://content.sportslogos.net/logos/35/920/thumbs/92018352019.gif",
}

export const mlbImageUrls: Record<string, string> = {
    // American League
    "Athletics": "https://content.sportslogos.net/logos/53/6921/thumbs/692150012025.gif",
    "Blue Jays": "https://content.sportslogos.net/logos/53/78/thumbs/7889872020.gif",
    "Orioles": "https://content.sportslogos.net/logos/53/52/thumbs/5258002019.gif",
    "White Sox": "https://content.sportslogos.net/logos/53/55/thumbs/oxvkprv7v4inf5dgqdebp0yse.gif",
    "Guardians": "https://content.sportslogos.net/logos/53/6804/thumbs/680455382022.gif",
    "Tigers": "https://content.sportslogos.net/logos/53/59/thumbs/5989642016.gif",
    "Astros": "https://content.sportslogos.net/logos/53/4929/thumbs/492995032000.gif",
    "Royals": "https://content.sportslogos.net/logos/53/62/thumbs/6283222019.gif",
    "Angels": "https://content.sportslogos.net/logos/53/6521/thumbs/652143892016.gif",
    "Twins": "https://content.sportslogos.net/logos/53/65/thumbs/6539532023.gif",
    "Yankees": "https://content.sportslogos.net/logos/53/68/thumbs/1256.gif",
    "Mariners": "https://content.sportslogos.net/logos/53/75/thumbs/1305.gif",
    "Rays": "https://content.sportslogos.net/logos/53/2535/thumbs/253594482019.gif",
    "Rangers": "https://content.sportslogos.net/logos/53/77/thumbs/7755052024.gif",
    "Red Sox": "https://content.sportslogos.net/logos/53/53/thumbs/c0whfsa9j0vbs079opk2s05lx.gif",

    // National League
    "Diamondbacks": "https://content.sportslogos.net/logos/54/50/thumbs/5031252024.gif",
    "Braves": "https://content.sportslogos.net/logos/54/51/thumbs/5124352022.gif",
    "Cubs": "https://content.sportslogos.net/logos/54/54/thumbs/q9gvs07u72gc9xr3395u6jh68.gif",
    "Reds": "https://content.sportslogos.net/logos/54/56/thumbs/z9e0rqit393ojiizsemd0t1hx.gif",
    "Rockies": "https://content.sportslogos.net/logos/54/58/thumbs/5868712017.gif",
    "Dodgers": "https://content.sportslogos.net/logos/54/63/thumbs/efvfv5b5g1zgpsf56gb04lthx.gif",
    "Marlins": "https://content.sportslogos.net/logos/54/3637/thumbs/363775442019.gif",
    "Brewers": "https://content.sportslogos.net/logos/54/64/thumbs/6464742020.gif",
    "Mets": "https://content.sportslogos.net/logos/54/67/thumbs/new_york_mets_logo_primary_1999sportslogosnet8711.gif",
    "Phillies": "https://content.sportslogos.net/logos/54/70/thumbs/7075792019.gif",
    "Pirates": "https://content.sportslogos.net/logos/54/71/thumbs/7112502014.gif",
    "Padres": "https://content.sportslogos.net/logos/54/73/thumbs/7375172020.gif",
    "Giants": "https://content.sportslogos.net/logos/54/74/thumbs/cpqj6up5bvgpoedg5fwsk20ve.gif",
    "Cardinals": "https://content.sportslogos.net/logos/54/72/thumbs/3zhma0aeq17tktge1huh7yok5.gif",
    "Nationals": "https://content.sportslogos.net/logos/54/578/thumbs/rcehah9k0kekjkgzm077fflws.gif"
};

    // "Cardinals": "https://content.sportslogos.net/logos/7/177/thumbs/kwth8f1cfa2sch5xhjjfaof90.gif",
    // "Falcons": "https://content.sportslogos.net/logos/7/173/thumbs/299.gif",
    // "Ravens": "https://content.sportslogos.net/logos/7/153/thumbs/318.gif",
    // "Bills": "https://content.sportslogos.net/logos/7/149/thumbs/n0fd1z6xmhigb0eej3323ebwq.gif",
    // "Panthers": "https://content.sportslogos.net/logos/7/174/thumbs/f1wggq2k8ql88fe33jzhw641u.gif",
export const nflImageUrls: Record<string, string> = {
    "Bears": "https://content.sportslogos.net/logos/7/169/thumbs/364.gif",
    "Bengals": "https://content.sportslogos.net/logos/7/154/thumbs/15420492021.gif",
    "Bills": "https://content.sportslogos.net/logos/7/149/thumbs/n0fd1z6xmhigb0eej3323ebwq.gif",
    "Broncos": "https://content.sportslogos.net/logos/7/161/thumbs/9ebzja2zfeigaziee8y605aqp.gif",
    "Browns": "https://content.sportslogos.net/logos/7/155/thumbs/15566962024.gif",
    "Buccaneers": "https://content.sportslogos.net/logos/7/176/thumbs/17683632020.gif",
    "Cardinals": "https://content.sportslogos.net/logos/7/177/thumbs/kwth8f1cfa2sch5xhjjfaof90.gif",
    "Chargers": "https://content.sportslogos.net/logos/7/6446/thumbs/644616602020.gif",
    "Chiefs": "https://content.sportslogos.net/logos/7/162/thumbs/kansas_city_chiefs_logo_primary_1972sportslogosnet6237.gif",
    "Colts": "https://content.sportslogos.net/logos/7/158/thumbs/593.gif",
    "Commanders": "https://content.sportslogos.net/logos/7/6832/thumbs/683260482022.gif",
    "Cowboys": "https://content.sportslogos.net/logos/7/165/thumbs/406.gif",
    "Dolphins": "https://content.sportslogos.net/logos/7/150/thumbs/15073062018.gif",
    "Eagles": "https://content.sportslogos.net/logos/7/167/thumbs/960.gif",
    "Falcons": "https://content.sportslogos.net/logos/7/173/thumbs/299.gif",
    "Fortyniners": "https://content.sportslogos.net/logos/7/179/thumbs/17994552009.gif",
    "Giants": "https://content.sportslogos.net/logos/7/166/thumbs/919.gif",
    "Jaguars": "https://content.sportslogos.net/logos/7/159/thumbs/15988562013.gif",
    "Jets": "https://content.sportslogos.net/logos/7/152/thumbs/15291162019.gif",
    "Lions": "https://content.sportslogos.net/logos/7/170/thumbs/17013982017.gif",
    "Packers": "https://content.sportslogos.net/logos/7/171/thumbs/dcy03myfhffbki5d7il3.gif",
    "Panthers": "https://content.sportslogos.net/logos/7/174/thumbs/f1wggq2k8ql88fe33jzhw641u.gif",
    "Patriots": "https://content.sportslogos.net/logos/7/151/thumbs/y71myf8mlwlk8lbgagh3fd5e0.gif",
    "Raiders": "https://content.sportslogos.net/logos/7/6708/thumbs/670885212020.gif",
    "Rams": "https://content.sportslogos.net/logos/7/5941/thumbs/594183342020.gif",
    "Ravens": "https://content.sportslogos.net/logos/7/153/thumbs/318.gif",
    "Saints": "https://content.sportslogos.net/logos/7/175/thumbs/907.gif",
    "Seahawks": "https://content.sportslogos.net/logos/7/180/thumbs/pfiobtreaq7j0pzvadktsc6jv.gif",
    "Steelers": "https://content.sportslogos.net/logos/7/156/thumbs/970.gif",
    "Texans": "https://content.sportslogos.net/logos/7/157/thumbs/570.gif",
    "Titans": "https://content.sportslogos.net/logos/7/160/thumbs/1053.gif",
    "Vikings": "https://content.sportslogos.net/logos/7/172/thumbs/17227042013.gif"
};

export const ncaafbImageUrls: Record<string, string> = {

};
